import React, { useEffect, useState, useCallback } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { adminActivity, apiError } from "../../lib/adminApi";
import { fmtDate, inputCls, btnGhost, Empty } from "./ui";
import { KIND_LABEL } from "./UserDetail";

const DOT = { wa_msg: "#25D366", wa_pdf: "#25D366", quote_wa: "#25D366", quote_web: "#38BDF8", pdf_web: "#38BDF8", signup: "#f59e0b", expectation: "#f59e0b", login: "#64748b", app_seen: "#64748b", member_created: "#f472b6", member_updated: "#f472b6" };

export default function AdminActivity() {
  const [events, setEvents] = useState(null);
  const [kind, setKind] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    setBusy(true);
    try { setEvents((await adminActivity({ limit: 150, kind })).events); } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  }, [kind]);

  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);

  return (
    <div className="space-y-5" data-testid="admin-activity">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Atividade</h1>
          <p className="text-[13px] text-slate-400 mt-1">Feed ao vivo (atualiza a cada 30s): cadastros, acessos, orçamentos, WhatsApp e PDFs.</p>
        </div>
        <div className="flex gap-2">
          <select value={kind} onChange={(e) => setKind(e.target.value)} className={`${inputCls} w-48`} data-testid="activity-filter">
            <option value="">Tudo</option>
            {Object.entries(KIND_LABEL).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
          <button onClick={load} disabled={busy} className={btnGhost} data-testid="activity-refresh"><RefreshCw size={14} className={busy ? "animate-spin" : ""} /></button>
        </div>
      </div>
      {events === null ? <div className="text-slate-500 text-[13px]">Carregando…</div> : events.length === 0 ? <Empty text="Nenhum evento ainda" /> : (
        <ol className="relative border-l border-white/10 ml-2 space-y-1">
          {events.map((e, i) => (
            <li key={i} className="pl-5 py-2 relative" data-testid={`event-${i}`}>
              <span className="absolute -left-[5px] top-[15px] w-2.5 h-2.5 rounded-full ring-2 ring-[#0B0F19]" style={{ background: DOT[e.kind] || "#64748b" }} />
              <div className="flex flex-wrap items-baseline gap-x-2 text-[13px]">
                <span className="font-medium">{KIND_LABEL[e.kind] || e.kind}</span>
                <span className="text-slate-400">{e.user ? (e.user.name || e.user.email) : e.meta?.phone ? `+${e.meta.phone}` : e.meta?.email || "—"}</span>
                {e.meta?.client && <span className="text-slate-500">· {e.meta.client}</span>}
                {e.meta?.text && <span className="text-slate-500 truncate max-w-[420px]">· “{e.meta.text}”</span>}
                {e.meta?.by && <span className="text-slate-500">· por {e.meta.by}</span>}
                <span className="ml-auto text-[11.5px] text-slate-500 font-mono-jb">{fmtDate(e.at, true)}</span>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
